module.exports = __webpack_public_path__ + "static/media/Close.31dc1b5b.svg";